import { curry } from 'ramda';

export const debugLog = curry((message, argObj) => {
  if (process.env.NODE_ENV !== 'test') console.log(`DEBUG: ${message}`, argObj);
  return argObj;
});

